// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.login-container {
    width: 100vw;
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;

    background: #f4f4f4;
}

.login-tile {
    width: 350px;

    display: flex;
    flex-direction: column;
    gap: 15px;

    padding: 30px;

    background: white;

    border-radius: 12px;

    box-shadow:
        0 4px 12px rgba(0, 0, 0, 0.15);
}

.login-tile h1 {
    margin: 0;
    text-align: center;
    color: #333;
}

.login-tile input {
    padding: 12px;

    border: 1px solid #d0d0d0;
    border-radius: 6px;

    font-size: 16px;
}

.login-button {
    padding: 12px;

    background: #28a745;
    color: white;

    border: none;
    border-radius: 6px;

    font-size: 16px;
    font-weight: bold;

    cursor: pointer;

    transition:
        background-color 0.2s,
        transform 0.1s;
}

.login-button:hover {
    background: #218838;
}

.login-button:active {
    transform: scale(0.98);
}

.create-account-button { padding: 12px; background: #0d6efd; color: white; border: none; border-radius: 6px; font-size: 16px; font-weight: bold; cursor: pointer; transition: background-color 0.2s, transform 0.1s; } .create-account-button:hover { background: #0b5ed7; } .create-account-button:active { transform: scale(0.98); }
`, "",{"version":3,"sources":["webpack://./src/css/Login.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,aAAa;;IAEb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;;IAEZ,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET,aAAa;;IAEb,iBAAiB;;IAEjB,mBAAmB;;IAEnB;sCACkC;AACtC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;;IAEb,yBAAyB;IACzB,kBAAkB;;IAElB,eAAe;AACnB;;AAEA;IACI,aAAa;;IAEb,mBAAmB;IACnB,YAAY;;IAEZ,YAAY;IACZ,kBAAkB;;IAElB,eAAe;IACf,iBAAiB;;IAEjB,eAAe;;IAEf;;sBAEkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,iBAAiB,EAAE,eAAe,EAAE,iDAAiD,EAAE,EAAE,+BAA+B,mBAAmB,EAAE,EAAE,gCAAgC,sBAAsB,EAAE","sourcesContent":["\n.login-container {\n    width: 100vw;\n    height: 100vh;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    background: #f4f4f4;\n}\n\n.login-tile {\n    width: 350px;\n\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n\n    padding: 30px;\n\n    background: white;\n\n    border-radius: 12px;\n\n    box-shadow:\n        0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.login-tile h1 {\n    margin: 0;\n    text-align: center;\n    color: #333;\n}\n\n.login-tile input {\n    padding: 12px;\n\n    border: 1px solid #d0d0d0;\n    border-radius: 6px;\n\n    font-size: 16px;\n}\n\n.login-button {\n    padding: 12px;\n\n    background: #28a745;\n    color: white;\n\n    border: none;\n    border-radius: 6px;\n\n    font-size: 16px;\n    font-weight: bold;\n\n    cursor: pointer;\n\n    transition:\n        background-color 0.2s,\n        transform 0.1s;\n}\n\n.login-button:hover {\n    background: #218838;\n}\n\n.login-button:active {\n    transform: scale(0.98);\n}\n\n.create-account-button { padding: 12px; background: #0d6efd; color: white; border: none; border-radius: 6px; font-size: 16px; font-weight: bold; cursor: pointer; transition: background-color 0.2s, transform 0.1s; } .create-account-button:hover { background: #0b5ed7; } .create-account-button:active { transform: scale(0.98); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
